import { getApp as getApp$1, getApps, initializeApp } from 'firebase/app';

const DEFAULT_APP_NAME = "[DEFAULT]";
const getApp = (config, _name = DEFAULT_APP_NAME) => {
  if (_name !== DEFAULT_APP_NAME) {
    return getApp$1(_name);
  }
  const apps = getApps();
  if (apps.length !== 0) {
    return apps.find(({ name }) => name === _name);
  }
  if (config) {
    return initializeApp(config, _name);
  }
  throw Error(
    "[@flex/firebase > getApp]: Does Not Initialized app with app config"
  );
};

export { getApp };
//# sourceMappingURL=getApp.mjs.map
